export const pressReleases = [
  {
    title: "Kalshi Clone Script Development",
    link: "/kalshi-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766102/KalshiCloneScriptDevelopment_hgmgwm.webp",
    alt: "Kalshi Clone Script Development",
    content:
      "Your Kalshi-like prediction market platform is fully ready to deploy on your server. With our expert support, turning your prediction market dream into reality is easier than ever.",
  },
  {
    title: "Asset Tokenization Step by Step Guide",
    link: "/asset-tokenization-step-by-step-guide",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766212/AssetTokenizationStepbyStepGuide_i0wwaa.webp",
    alt: "Asset Tokenization",
    content:
      "Learn step by step secure and scalable asset tokenization to digitize real-world assets",
  },
  {
    title: "Play to Earn Game Development Company",
    link: "/play-to-earn-game-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766375/PlaytoEarnGameDevelopmentCompany_idbnt8.webp",
    alt: "Play to Earn Game Development Company",
    content:
      "Build Rewarding Digital Worlds for the Future of Gaming",
  },
  {
    title: "White Label Tokenization Platform Development Company",
    link: "/white-label-tokenization-platform-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766440/WhiteLabelTokenizationPlatformDevelopmentCompany_txqlo8.webp",
    alt: "white label tokenization",
    content:
      "Our complete white label tokenization platform development service helps you achieve your entrepreneur goals.",
  },
  // {
  //   title: "Diamond Tokenization Development ",
  //   link: "/diamond-tokenization-development",
  //   imgSrc:
  //     "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776763480/DiamondTokenizationDevelopment_squwul.webp",
  //   alt: "Diamond Tokenization Development ",
  //   content:
  //     "Build a Secure Diamond Tokenization Platform with beleaf technologies",
  // },
  {
    title: "Gold Tokenization Development ",
    link: "/gold-tokenization-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766514/GoldTokenizationDevelopment_fk0bqr.webp",
    alt: "Gold Tokenization Development  ",
    content:
      "Build Your Tokenized Gold Platform with beleaf technologies. This innovation bridges the gap...",
  },
  {
    title: "XAUUSD Trading Bot Development ",
    link: "/xauusd-trading-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766577/XAUUSDTradingBotDevelopment_m4xjie.webp",
    alt: "XAUUSD Trading Bot Development  ",
    content:
      "Get started on Gold trading with our ai powered XAUUSD Trading Bot",
  },
  {
    title: "DApp Audit Company ",
    link: "/dapp-audit-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766667/DAppAuditCompany_udnnag.webp",
    alt: "DApp Audit Company  ",
    content:
      "Audit your Dapp in no time have free consultation from our experts.",
  },
  {
    title: "How to Make a Meme Coin ",
    link: "/how-to-make-a-meme-coin",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776766815/HowtoMakeaMemeCoin_qpwus7.webp",
    alt: "How to Make a Meme Coin  ",
    content:
      "Are you curious about how to make a meme coin and ride the wave of internet culture and crypto hype? In recent...",
  },
  {
    title: "Bet365 Clone ",
    link: "/bet365-clone",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767137/Bet365Clone_zmjcjh.webp",
    alt: "Bet365 Clone ",
    content:
      " The global online betting industry is growing rapidly, and platforms like Bet365 have played a major role...",
  },
  {
    title: "Udemy Clone Script ",
    link: "/udemy-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767313/UdemyCloneScript_qiiztw.webp",
    alt: "Udemy Clone Script ",
    content:
      "The global eLearning industry is booming. With the rise in demand for online learning, creating an eLearning platform like Udemy...",
  },
  {
    title: "Netflix Clone ",
    link: "/netflix-clone",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767351/NetflixClone_jhxtb7.webp",
    alt: "Netflix Clone ",
    content:
      "Over the last ten years, the entertainment industry has undergone a major shift. With the rise of the internet and smartphones, viewers have moved...",
  },
  {
    title: "Crypto Derivatives Exchange Development Company",
    link: "/crypto-derivatives-exchange-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767421/CryptoDerivativesExchangeDevelopmentCompany_kotwsi.webp",
    alt: "Crypto Derivatives Exchange Development Company",
    content:
      "Are you a startup or individual looking to build your own crypto derivatives exchanges. Beleaf technologies will got you covered...",
  },
  {
    title: "Options Trading Crypto Exchange Development Company",
    link: "/options-trading-crypto-exchange-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767494/OptionsTradingCryptoExchangeDevelopmentCompany_ghqsbe.webp",
    alt: "Options Trading Crypto Exchange Development Company",
    content:
      "One of the fastest-growing areas is options trading. Options trading gives traders more flexibility...",
  },
  {
    title: "Spot Trading Crypto Exchange Development",
    link: "/spot-trading-crypto-exchange-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767584/SpotTradingCryptoExchangeDevelopment_xcbjc7.webp",
    alt: "Spot Trading Crypto Exchange Development",
    content:
      "A spot trading crypto exchange development company helps businesses and entrepreneurs create powerful trading platforms...",
  },
  {
    title: "Cricket Betting App Development Company",
    link: "/cricket-betting-app-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767677/CricketBettingAppDevelopmentCompany_pjictm.webp",
    alt: "Cricket Betting App Development Company",
    content:
      "Our cricket betting app development services provide everything you need to succeed in a competitive market.",
  },
  {
    title: "Dream11 clone app for fantasy cricket business",
    link: "/dream11-clone-app",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767803/Dream11cloneapp_hsmxhp.webp",
    alt: "Dream11 clone app",
    content:
      "Your best option to enter cricket betting and fantasy sports betting market",
  },
  {
    title: "Ludo Game Development Company",
    link: "/ludo-game-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767862/LudoGameDevelopmentCompany_zzvu8v.webp",
    alt: "Ludo Game Development Company",
    content:
      "Build Engaging, Scalable & Profitable Ludo Apps with perfect Ludo game developers",
  },
  {
    title: "AI Development Services",
    link: "/ai-development-services",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776767992/AIDevelopmentServices_gfsn3w.webp",
    alt: "AI Development Services",
    content:
      "Build Smarter, Faster, and Future-Ready Solutions with our industry grade Ai developers",
  },
  {
    title: "ChatGPT Clone Development",
    link: "/chatGPT-clone-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768079/ChatGPTCloneDevelopment_ihkzkc.webp",
    alt: "ChatGPT Clone Development",
    content:
      "Generate Text, Image etc have a conversation with AI Get instant human like response with Chatgpt Clone. ",
  },
  {
    title: "Proven Method For Crypto Exchange Development",
    link: "/proven-method-for-crypto-exchange-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768136/ProvenMethodForCryptoExchangeDevelopment_aoytgt.webp",
    alt: "Proven Method For Crypto Exchange Development",
    content:
      "A Step by Step Approach to Build a Secure & Scalable Exchange",
  },
  {
    title: "OnlyFans Clone Script Development",
    link: "/onlyFans-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768212/OnlyFansCloneScriptDevelopment_bxfsva.webp",
    alt: "OnlyFans Clone Script Development",
    content:
      "Build a Profitable Subscription based content Platform with Onlyfans clone",
  },
  {
    title: "Sports Betting App Development Company",
    link: "/sports-betting-app-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768314/SportsBettingAppDevelopmentCompany_j2xdfq.webp",
    alt: "Sports Betting App Development Company",
    content:
      "Build Secure, Scalable & Profitable Betting Platforms",
  },
  {
    title: "Candy ai clone development your virtual ai girlfriend or boy friend app",
    link: "/candy-ai-clone-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768399/Candyaiclonedevelopment_qbysuv.webp",
    alt: "Candy ai clone development",
    content:
      "AI NSFW App Development Company like candy ai, Janitor ai",
  },
  {
    title: "Pump Fun Clone Script",
    link: "/pump-fun-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768450/PumpFunCloneScript_t0d6yj.webp",
    alt: "Pump Fun Clone Script",
    content:
      "Meme coins have taken center stage. One platform that revolutionized the way meme coins are created and launched is...",
  },
  {
    title: "Polymarket Copy Trading Bot Development",
    link: "/polymarket-copy-trading-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776841214/PolymarketCopyTradingBotDevelopment_bubyvt.webp",
    alt: "Polymarket Copy Trading Bot Development",
    content:
      "Smart Prediction Market Trading with polymarket copy trading bot",
  },
  {
    title: "Telegram Trading Bot Development",
    link: "/telegram-trading-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768516/TelegramTradingBotDevelopment_w9hcij.webp",
    alt: "Telegram Trading Bot Development",
    content:
      "Telegram, a widely used messaging platform, has evolved into a powerful hub for crypto traders to interact directly with...",
  },
  {
    title: "Fan Token Development",
    link: "/fan-token-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768574/FanTokenDevelopment_r6jjlo.webp",
    alt: "Fan Token Development",
    content:
      "Today, blockchain technology is revolutionizing how celebrities, sports teams, musicians, and influencers connect with their global audiences...",
  },
  {
    title: "VARA Registration",
    link: "/vara-registration",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776768990/VARARegistration_mfmkyj.webp",
    alt: "VARA Registration",
    content:
      "The UAE, especially Dubai, is becoming one of the most crypto-friendly places in the world. With clear laws, government support, and...",
  },
    {
    title: "Flash USDT Software Development",
    link: "/flash-usdt-software-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769066/FlashUSDTSoftwareDevelopment_ec6ikd.webp",
    alt: "flash-usdt-software-development",
    content:
      "Build secure, fast, and high-performance USDT Flash Software with advanced features, risk controls, and private dashboards.",
  },
    {
    title: "1xBet Clone Script",
    link: "/1xbet-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769143/1xBetCloneScript_qqz4ht.webp",
    alt: "1xBet Clone Script",
    content:
      "Build a Powerful Sports Betting Platform Like 1xBet",
  },
    {
    title: "Color Prediction Game Development Company",
    link: "/color-prediction-game-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769203/ColorPredictionGameDevelopmentCompany_fo2ddv.webp",
    alt: "Color Prediction Game Development Company",
    content:
      "Build a Profitable Color Prediction Game Platform",
  },
  {
    title: "Wallet Drainer Software Development in real time for Education Purposes",
    link: "/wallet-drainer-software-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1778227347/Wallet-Drainer-Software-Development_ofadgk.webp",
    alt: "Wallet Drainer Software Development",
    content:
      "Real-time wallet drainer software for education and Cyber security awareness purposes. You can drain any wallet in real time and educate people about threats and vulnerabilities",
  },
  {
    title: "Ondo Finance Clone Script Development",
    link: "/ondo-finance-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1779272870/Ondo-Finance-Clone_uyebnh.webp",
    alt: "Ondo Finance Clone Script Development",
    content:
      "Building a Tokenized Real-World Asset Platform like Ondo Finance with simple steps",
  },
  {
    title: "HaaNaa Clone Script",
    link: "/haaNaa-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1779947361/HaaNaaCloneScript_x6oqza.webp",
    alt: "HaaNaa Clone Script",
    content:
      "Launch Your Own Opinion Trading App Platform with our HaaNaa Clone Solution",
  },
  {
    title: "HaasOnline Clone Script for Your Own Crypto Trading Bot Platform business",
    link: "/haasOnline-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1779958104/HaasOnlineCloneScript_fhcera.webp",
    alt: "HaasOnline Clone Script",
    content:
      "Launch your crypto trading bot platform business with expert clone solution",
  },
  {
    title: "Case Study Of Prediction Market App Development Company",
    link: "/prediction-market-app-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1780045527/PredictionMarketAppDevelopment_fybkj4.webp",
    alt: "Prediction Market App Development",
    content:
      "A prediction app development case study for our client with End to End Prediction Market Development process and launch",
  },
  {
    title: "Limitless Clone Script",
    link: "/limitless-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1780128967/LimitlessCloneScript_aao8xb.webp",
    alt: "Limitless Clone Script",
    content:
      "Launch Your Own AI-Powered Prediction Market Platform",
  },
  {
    title: "Porter Clone Script Development",
    link: "/porter-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1780290676/PorterCloneScriptDevelopment_lv13sm.webp",
    alt: "Porter Clone Script Development",
    content:
      "Launch Your Own Porter Clone App for the Growing Logistics Industry",
  },
  {
    title: "Oracl.fun Clone Script A Complete Case Study With Cost, Timeline and Development Roadmap",
    link: "/oraclFun-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dqtdd1frp/image/upload/v1780301743/Oracl.funCloneScript_ug9uqb.webp",
    alt: "Oracl.fun Clone Script",
    content:
      "Learn to Launch a Decentralized Prediction Market.",
  },
  {
    title: "Sports Prediction Software Development With User Guide",
    link: "/sports-prediction-software-development",
    imgSrc:
      "https://res.cloudinary.com/dqtdd1frp/image/upload/v1781606910/SportsPredictionSoftwareDevelopment_mos0up.webp",
    alt: "Sports Prediction Software Development",
    content:
      "A complete Sports prediction software solution with complete user manual",
  },
  {
    title: "Football Prediction App Development",
    link: "/football-prediction-app-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1781674437/FootballPredictionAppDevelopment_jlhbki.jpg",
    alt: "Football Prediction App Development",
    content:
      "Building a Winning Football Prediction Platform with user manual",
  },
  {
    title: "WinZO Clone App Full working demo in 2026",
    link: "/winZO-clone-app-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1781865789/WinZOCloneApp_ogi0vq.webp",
    alt: "WinZO Clone App Development",
    content:
      "Build a Real Money Gaming Platform in 2026",
  },
  {
    title: "Chicken Road Clone Script Get Free Demo",
    link: "/chicken-road-game-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1782105466/ChickenRoadGameClone_yuatcg.webp",
    alt: "Chicken Road Clone Script",
    content:
      "Launch Your Own Viral Crash Gaming Platform like chicken road with prebuilt script solution",
  },
  {
    title: "AI Automation Agency",
    link: "/AI-automation-agency",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1782209782/AI-automation-agency_r5xfbw.webp",
    alt: "AI Automation Agency",
    content:
      "Transforming Businesses Through Intelligent Automation with AI",
  },
  {
    title: "Groww Clone App Development",
    link: "/groww-clone-app-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1782728796/GrowwCloneAppDevelopment_gyn6ka.webp",
    alt: "Groww Clone App Development",
    content:
      "Launch Your Own Investment Platform Like Groww",
  },
  {
    title: "Chicken Road Clone Script",
    link: "/chicken-road-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1782910360/ChickenRoadCloneScript_rbpe6z.webp",
    alt: "Chicken Road Clone Script",
    content:
      "Launch Your Own Viral Crash Gaming Platform in 2026",
  },
  {
    title: "AI Calling Agent in 2026 complete Guide",
    link: "/AI-calling-agent-with-high-precision",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1783166095/AICallingAgent_gdw97e.webp",
    alt: "AI Calling Agent in 2026 complete Guide",
    content:  
      "Ai Calling Agent to automate business and increase ROI.",
  },
  {
    title: "AI Girlfriend complete setup & Deployment",
    link: "/AI-girlfriend-the-future-of-virtual-AI-companionship",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1783339512/AIGirlfriendAICompanionship_l0ezuw.webp",
    alt: "AI Girlfriend The Future of Virtual AI Companionship",
    content:  
      "Your desired Ai companion with customizable features and avatars",
  },
  {
    title: "Agentic AI Development Company Complete Case Study",
    link: "/agentic-AI-development-company",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1783502113/AgenticAIDevelopment_x7feee.webp",
    alt: "Agentic AI Development with full setup case study",
    content:  
      "Enterprise Agentic Ai Development for all industries with world class solutions",
  },
  {
    title: "Crypto Wallet Drainer Software for Education in 2026",
    link: "/crypto-wallet-drainer-software",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1786187245/Crypto_Wallet_Drainer_Software_gdos5y.webp",
    alt: "Crypto Wallet Drainer Software for Education in 2026",
    content:  
      "Get crypto wallet drainer software for education and training purposes. Learn from live drainer operation in mainnet.",
  },
  {
    title: "Prediction Market Software in 2026 A Complete Guide to Building, Launching, and Scaling a Prediction Market Platform",
    link: "/prediction-market-software",
    imgSrc:
      "https://res.cloudinary.com/dqtdd1frp/image/upload/v1780493509/PredictionMarketSoftware_vsvm5m.webp",
    alt: "Prediction Market Software",
    content:
      "Prediction Market Software an successful business model to step into",
  },
  {
    title: "Parimatch Clone Script Full Working Demo",
    link: "/parimatch-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1778315297/ParimatchCloneScript_xqkddv.webp",
    alt: "Parimatch Clone Script",
    content:
      "Launch Your Own Sports Betting Platform with a Powerful Parimatch Clone Script",
  },
  {
    title: "Delta Exchange Clone Script",
    link: "/delta-exchange-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1778661320/delta-exchange-clone-script_ory1yk.webp",
    alt: "Delta Exchange Clone Script",
    content:
      "Build a Powerful Crypto Derivatives Trading Platform like Delta Exchange in India With FIU Registration support from us.",
  },
    {
    title: "Aviator Predictor Bot Development",
    link: "/aviator-predictor-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769353/AviatorPredictorBotDevelopment_syjqtr.webp",
    alt: "Aviator Predictor Bot Development",
    content:
      "Build a Powerful Aviator Bot Predictor for Smart Gaming Insights",
  },
    {
    title: "Quotex Clone App Script",
    link: "/quotex-clone-app-script", 
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769435/QuotexCloneAppScript_utivkz.webp",
    alt: "Quotex Clone App Script",
    content:
      "Build Your Own Profitable Trading Platform",
  },
    {
    title: "Roblox Clone Script Development in 2026",
    link: "/roblox-clone-script-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769560/RobloxCloneScriptDevelopment_x6y8ci.webp",
    alt: "Roblox Clone Script Development",
    content:
      "Build Your Own Gaming Platform Like Roblox",
  },
    {
    title: "Prediction Market Development Company",
    link: "/prediction-market-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769640/PredictionMarketDevelopmentCompany_cwssgw.webp",
    alt: "Prediction Market Development Company",
    content:
      "Building a Profitable prediction market Platform for your future proof business",
  },
    {
    title: "Manifold Markets Clone Script",
    link: "/manifold-markets-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769719/ManifoldMarketsCloneScript_wlq2i4.webp",
    alt: "Manifold Markets Clone Script",
    content:
      "Develop your prediction market platform like Manifold with expert developers",
  },
    {
    title: "Aviator Predictor App Development",
    link: "/aviator-predictor-app-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769798/AviatorPredictorAppDevelopment_ckzc42.webp",
    alt: "Aviator Predictor App Development",
    content:
      "Best Aviator Game prediction app development for your business needs",
  },
    {
    title: "Polymarket Trading Bot Development",
    link: "/polymarket-trading-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769875/PolymarketTradingBotDevelopment_fwwzzi.webp",
    alt: "Polymarket Trading Bot Development",
    content:
      "Build a Smart Prediction Market Bot for polymarket",
  },
    {
    title: "Colour Trading Clone App Development",
    link: "/colour-trading-clone-app-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776769958/ColourTradingCloneAppDevelopment_rvoz83.webp",
    alt: "Colour Trading Clone App Development",
    content:
      "Colour trading clone app for your prediction app business",
  },
    {
    title: "Flash BTC Software Development",
    link: "/flash-btc-software-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770029/FlashBTCSoftwareDevelopment_uz5doe.webp",
    alt: "Flash BTC Software Development",
    content:
      "Expert guidance for Flash BTC Software Development",
  },
  {
    title: "Sniper Bot Development",
    link: "/sniper-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770083/SniperBotDevelopment_qzdolg.webp",
    alt: "Sniper Bot Development",
    content:
      "Looking to stay ahead in the crypto market? With our sniper bot development service, you can gain the ultimate edge by...",
  },
  {
    title: "MLM Software Development Company",
    link: "/mlm-software-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770173/MLMSoftwareDevelopmentCompany_izve1m.webp",
    alt: "MLM Software Development Company",
    content:
      "Develop your MLM Software and start running your business Without any hassles",
  },
  {
    title: "Bet365 Bot Development",
    link: "/bet365-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1789204520/Bet365BotDevelopment_wtxylg.webp",
    alt: "Bet365 Bot Development",
    content:
      "Automated Betting Software for Bet365",
  },
  {
    title: "Crypto Card Development Company",
    link: "/crypto-card-development-company",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1789385889/CryptoCardDevelopmentCompany_ludoz7.webp",
    alt: "Crypto Card Development Company",
    content:
      "Whitelabel Crypto Credit / Debit Card Development solutions for your business model",
  },
  {
    title: "CoinPayments Clone Script",
    link: "/coinPayments-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1789987683/CoinPaymentsCloneScript_zdf2b8.webp",
    alt: "CoinPayments Clone Script",
    content:
      "Launch a Feature-Rich Crypto Payment Gateway like CoinPayments Clone Script",
  },
  {
    title: "Trust Wallet Clone Script",
    link: "/trust-wallet-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1790153191/TrustWalletCloneScript_nsxx0g.webp",
    alt: "Trust Wallet Clone Script",
    content:
      "Launch a Secure and Customizable Trust Wallet-Like Crypto Wallet ",
  },
  {
    title: "Private Equity Tokenization Development",
    link: "/private-equity-tokenization-development",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1790324370/PrivateEquityTokenization_yo53dd.webp",
    alt: "Private Equity Tokenization Development",
    content:
      "Turn eligible private equity interests into digitally managed, blockchain-based investment assets with a customized private equity tokenization platform.",
  },
  {
    title: "BC Game Clone Script",
    link: "/bc-game-clone-script",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770224/BCGameCloneScript_jx4bzv.webp",
    alt: "BC Game Clone Script",
    content:
      "Are you ready to build the next-generation crypto casino, similar to BC.Game? Our innovative BC Game clone script is your all-in-one solution to entering the thriving crypto gambling...",
  },

  {
    title: "Crypto Copy Trading Software Development",
    link: "/crypto-copy-trading-software-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770287/CryptoCopyTradingSoftwareDevelopment_b2tdgk.webp",
    alt: "Crypto Copy Trading Software Development",
    content:
      "Innovation drives success in the crypto market. One such innovation reshaping how traders participate in the...",
  },
  {
    title: "White Label Crypto Wallet Solution",
    link: "/white-label-crypto-wallet-solution",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1790748342/WhiteLabelCryptoWalletSolution_ffckks.webp",
    alt: "White Label Crypto Wallet Solution",
    content:
      "Launch a Secure, Scalable & Customizable custodial & non custodial, Multi currency Crypto Wallet Faster with beleaf technologies in 7 Days",
  },
  {
    title: "RWA Marketplace Development Company",
    link: "/RWA-marketplace-development-company",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1791786299/RWAMarketplaceDevelopment_rvyd7b.jpg",
    alt: "RWA Marketplace Development Company",
    content:
      "Build a secure, scalable, and feature-rich RWA marketplace with customized blockchain technology.",
  },
  {
    title: "Top AI Agent Development Companies in 2026 Detailed Guide",
    link: "/top-ai-agent-development-companies-in-2026",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1791960155/TopAIAgentDevelopmentCompanies_cqplbb.jpg",
    alt: "Top AI Agent Development Companies in 2026",
    content:
      "Explore the top AI agent development companies in 2026. Compare AI expertise, services, technologies, costs, and tips for choosing the right development partner.",
  },
  {
    title: "Blockchain Trade Finance Solutions",
    link: "/blockchain-trade-finance-solutions",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1792396649/blockchaintradefinancesolutions_1_q05bkr.webp",
    alt: "Blockchain Trade Finance Solutions",
    content:
      "Trade Finance On Chain: Transform Global Trade With Blockchain Technology",
  },
  {
    title: "Agentic Payments: Ultimate Guide to AI-Driven Payments Infrastructure",
    link: "/agentic-payments-ultimate-guide-to-AI-driven-payments-infrastructure",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1792565466/agenticpaymentsimg_1_cphhke.webp",
    alt: "Agentic Payments Guide",
    content:
      "Artificial intelligence is changing how businesses discover products, manage financial operations, and complete digital transactions.",
  },
  {
    title: "AI Workflow Automation Services for Businesses",
    link: "/AI-workflow-automation-services",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1793355128/aiworkflowautomationservices_1_re6c4a.webp",
    alt: "AI Workflow Automation Services for Businesses",
    content:
      "Automate Business Processes, Improve Productivity, and Accelerate Growth with AI",
  },
  {
    title: "RWA Tokenization Platform Development Company",
    link: "/RWA-tokenization-platform-development-company",
    imgSrc:
      "https://res.cloudinary.com/dr3lpkvua/image/upload/v1793355522/RWATokenizationPlatform_pkwekg.webp",
    alt: "RWA Tokenization Platform Development Company",
    content:
      "Build a Secure, Scalable, and Compliant Real-World Asset Tokenization Platform",
  },
  {
    title: "HFT Trading Bot Development",
    link: "/hft-trading-bot-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770422/HFTTradingBotDevelopment_tsxrxt.webp",
    alt: "HFT Trading Bot Development",
    content:
      "One of the most advanced strategies utilized today is high-frequency trading (HFT), and at the core of...",
  },
  {
    title: "Blockchain App Development Company",
    link: "/blockchain-app-development-company",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770473/BlockchainAppDevelopmentCompany_jvhfdt.webp",
    alt: "Blockchain App Development Company",
    content:
      "Blockchain technology is changing how businesses operate. Whether it’s secure financial transactions, transparent...",
  },
  {
    title: "Probo Clone",
    link: "/probo-clone",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770546/ProboClone_luufpg.webp",
    alt: "Probo clone",
    content:
      "Prediction markets have carved a unique niche for themselves. Among these, Probo stands out as...",
  },
  {
    title: "Currency Trading Bot",
    link: "/Currency-Trading-Bot",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770606/CurrencyTradingBot_jehwui.webp",
    alt: "currency trading bot",
    content:
      "Developing a currency trading bot has become a pivotal strategy for traders aiming to automate their...",
  },
  {
    title: "Gold Trading Bot",
    link: "/Gold-Trading-Bot",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770719/GoldTradingBot_kwhhih.webp",
    alt: "Gold Trading Bot",
    content:
      "Gold has always been a popular investment. With technology, the way we trade gold is changing. One...",
  },
  {
    title: "How to Build a Crypto Exchange",
    link: "/how-to-build-crypto-exchange",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770799/HowtoBuildaCryptoExchange_xycklt.webp",
    alt: "How to Build a Crypto Exchange",
    content:
      "With the rise of digital assets, entrepreneurs and businesses are exploring how to build a crypto exchange to enter the booming cryptocurrency market. A cryptocurrency...",
  },
  {
    title: "Crypto Exchange Software Development Led By...",
    link: "/crypto-exchange-software-development",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776771527/CryptoExchangeSoftwareDevelopment_ezjr0t.webp",
    alt: "Crypto Exchange Software Development",
    content:
      "We are a top-tier blockchain development company, changing the industry with our innovative crypto exchange software development services. Our company is...",
  },
  {
    title: "Beleaf Technologies Leads the Way in Cash...",
    link: "/cash-advance-app-development-like-wagetap",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776771667/BeleafTechnologiesLeads_lmglrq.webp",
    alt: "Cash Advance App Development Like Wagetap",
    content:
      "Beleaf Technologies, a leading fintech solutions provider, is changing the financial world with its cutting-edge Cash Advance App Development services. By developing...",
  },
  {
    title: "ROKSY The Best Meme Coin to...",
    link: "/roksy-the-best-meme-coin-to-buy-now",
    imgSrc:
      "https://res.cloudinary.com/dvym3pvnu/image/upload/v1776771782/ROKSYTheBestMemeCoin_p4g2qw.webp",
    alt: "ROKSY The Best Meme Coin to Buy Now",
    content:
      "We are thrilled to introduce ROKSY, the new meme coin developed by beleaf technologies that continues the legendary legacy...",
  },
];
